import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import { fragments } from '../../../../gql'

const DOC = gql`
  ${fragments.breadcrumb.DOC}
  query MosaicPageSegmentInfo(
    $appPageId: ID!
    $pageId: ID!
    $scenarioId: ID!
    $appId: ID!
    $zoneId: ID!
    $tenantId: ID!
    $alias: ID!
    $variableOverrides: [VariableValueInput!]
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            mosaicPageRendering(
              appPageId: $appPageId
              variableOverrides: $variableOverrides
            ) {
              segment(alias: $alias, pageId: $pageId) {
                breadcrumbs {
                  ...FragmentBreadcrumb
                }
                name
                hide
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.MosaicPageSegmentInfoQuery,
  ents.core.mosaic.Page.Segment.Rendering,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'mosaicPageRendering',
          graphql.transformers.OUT.select(
            'segment',
            graphql.transformers.OUT.object({
              breadcrumbs: graphql.transformers.OUT.list(
                fragments.breadcrumb.TRANSFORMER,
                { onNullish: 'remove' },
              ),
              isHidden: {
                usingFullInput: graphql.transformers.OUT.select(
                  'hide',
                  transformers.PASS_THROUGH,
                ),
              },
              name: transformers.PASS_THROUGH,
            }),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.MosaicPageSegmentInfoQuery,
  ents.core.mosaic.Page.Segment.Rendering | undefined,
  graphql.schema.MosaicPageSegmentInfoQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
